module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/sol-logo-midnight-miracle.6dee2c2.png";